var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8243 3.82653C5.59524 2.05559 8.4665 2.05559 10.2374 3.82653C12.0084 5.59747 12.0084 8.46873 10.2374 10.2397C8.4665 12.0106 5.59524 12.0106 3.8243 10.2397C2.05336 8.46873 2.05336 5.59747 3.8243 3.82653ZM12.0052 2.05876C9.25796 -0.688491 4.80378 -0.688491 2.05653 2.05876C-0.690719 4.80601 -0.690719 9.26018 2.05653 12.0074C4.50219 14.4531 8.30057 14.7216 11.0432 12.8129L13.8659 15.6355C14.354 16.1237 15.1455 16.1237 15.6336 15.6355C16.1218 15.1474 16.1218 14.3559 15.6336 13.8678L12.8109 11.0451C14.7193 8.30243 14.4507 4.5043 12.0052 2.05876Z",
    fill: "#FFA842"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeSearch);
export default __webpack_public_path__ + "static/media/orange_search.bc7ee88441309f3d5c3409aabe38bae8.svg";
export { ForwardRef as ReactComponent };